import { observable } from 'mobx';
import { jumpPage } from '@src/utils/common-util';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { useLayerData } from '@src/utils/hooks/use-layer-data';

class newPageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 版本信息列表
  @observable NewsInformationList;
  @observable tabName = {};
  // 是否激活
  @observable isActive = false;
  // 选中tab
  @observable tabActive = '';
  // 动画
  @observable Animating = true;
  @observable part3Date;

  /**
   * 情报内容轮播图
   * @type {BaseSwiperStore}
   */
  informationSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 10,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000
      },
      effect: 'slide',
      allowTouchMove: true
    }
  });
  toList() {
    if (!IS_DEV_ENV) {
      const url = 'news-list.html';
      jumpPage(url, '#/');
    } else {
      this.mainStore?.redirect('/news-list');
    }
  }
  // 跳转详情
  toDetails = news_id => {
    // IS_DEV_ENV  DEPLOY_ENV
    if (!IS_DEV_ENV) {
      const url = 'news-detail.html';
      jumpPage(url, `#/?contentId=${news_id}`);
    } else {
      this.mainStore?.redirect(`/news-detail?contentId=${news_id}`);
    }
  };
  // 切换tab
  changeTab = key => {
    this.Animating = true;
    this.tabActive = key;
  };
  // 时间戳转时间
  timestampToTime(timestamp) {
    // 创建 Date 对象，注意如果时间戳是秒为单位，需要乘以 1000 转换为毫秒
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    // 月份从 0 开始，所以要加 1，并且不足两位时前面补 0
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    // 拼接成常见的时间格式
    return `${year}-${month}-${day} `;
    // ${hours}:${minutes}:${seconds}
  }
  use() {
    const part3Date = useLayerData('newPageData');

    useEffect(
      () => {
        if (!part3Date) {
          return;
        }
        this.part3Date = part3Date;
        this.NewsInformationList = part3Date.article_swipers || [];
        for (const item of part3Date.article_tabs) {
          this.tabName[item.tab_key] = item.tab_title;
        }
        this.tabActive = part3Date.article_tabs[0].tab_key;
      },
      [part3Date]
    );
    useEffect(
      () => {
        if (this.isActive) {
          this.Animating = true;
          const timer = setTimeout(() => {
            this.Animating = false;
          }, 600); // 动画持续时间 300ms

          return () => clearTimeout(timer);
        }
      },
      [this.isActive]
    );
    useEffect(
      () => {
        const timer = setTimeout(() => {
          this.Animating = false;
        }, 600); // 动画持续时间 300ms

        return () => clearTimeout(timer);
      },
      [this.tabActive]
    );
  }
}

export default newPageStore;
